import { render, staticRenderFns } from "./FeedProductFaultsTab.vue?vue&type=template&id=1537f9da&"
import script from "./FeedProductFaultsTab.vue?vue&type=script&lang=ts&"
export * from "./FeedProductFaultsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports